import { attempt } from "@omni/utils/function.utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Spinner } from "@/components/General/Spinner/spinner.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { useThunkDispatch } from "@/redux/dispatcher";
import { loadOrderById } from "@/redux/modules/api/data/orderDetail/orderDetail.module";
import * as OrderDetailsSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";

import { OrderDetailComponent } from "./orderDetail.component";

type Props = {
    orderid: string;
    additionalServiceTooltip?: string;
};

const OrderDetail = ({ orderid, additionalServiceTooltip }: Props) => {
    const dispatch = useThunkDispatch();
    const orderDetails = useSelector(OrderDetailsSelectors.getOrder);
    const isLoading = useSelector(OrderDetailsSelectors.isLoading);

    const tooltip: TooltipType | undefined = attempt(
        () => JSON.parse(additionalServiceTooltip ?? ""),
        undefined
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(loadOrderById(orderid));
    }, []);

    return (
        <>
            {isLoading && <Spinner />}
            {!isLoading && orderDetails && (
                <OrderDetailComponent
                    orderDetails={orderDetails}
                    additionalServiceTooltip={tooltip}
                />
            )}
        </>
    );
};

export { OrderDetail };
